import { Messages } from '../../../../codegen/Localize';
import { RunFlowTaskInfo } from '../../../../ts/models/RunFlowTaskInfo';
import { runFlowTaskChangeSchedule } from '../../../actions/spaces/RunFlowTaskMenuActions';
import { AppState } from '../../../state/AppState';
import { EntityActionNames, IEntityAction } from './IEntityAction';

export const RunFlowTaskChangeScheduleAction: IEntityAction<RunFlowTaskInfo, {}> = {
  name: EntityActionNames.TasksChangeSchedule,
  translateName: Messages.changeSchedule_action,
  isVisible: (targetItems: RunFlowTaskInfo[], state: AppState) => {
    return targetItems.length > 0;
  },
  isClickable: (_availableActions: {}, targetItems: RunFlowTaskInfo[]) => {
    return targetItems.length > 0;
  },
  createReduxAction: (targetItems: RunFlowTaskInfo[]) => runFlowTaskChangeSchedule(targetItems)
};
